import { render, staticRenderFns } from "./ProfileGroupEditForm.vue?vue&type=template&id=25e1bdda"
import script from "./ProfileGroupEditForm.vue?vue&type=script&lang=js"
export * from "./ProfileGroupEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports